import { FC } from "react";
import { RadioGroupProps, Radio } from "antd";
import styles from "./LMRadio.module.css";

export const LMRadio: FC<RadioGroupProps> = ({ ...rest }) => {
  return <Radio.Group {...rest} className={styles.radio} />;
};

export const RadioButton = Radio.Button;
